export default "__VITE_ASSET__B87K0ImH__"